import styled from 'styled-components';
const WhiteBtn = styled.div`
  border: 1px solid #42AD1A;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  color: #42AD1A;
  cursor: pointer;
  min-width: ${({width})=>{return width || '100%'}};
  line-height: ${({heigth})=>{return heigth || ''}};
  height: ${({heigth})=>{return heigth || ''}};
  &:hover {
    background: linear-gradient(270deg,#74b310 0%,#147713 100%);
    color: #fff;
  }
`;

export default WhiteBtn;
